<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='card flat mt-none mb-sm row py-sm'>
  <div class='d-flex full-width align-items-center-forced p-none'>
    <div class='flex-grow-1 word-break-all d-inline-flex'>
      <well-person-circle [name]='bpContact?.contact?.contactName'
                          [companyName]='showCompanyForContact ? bpContact?.contact?.companyName : null'
                          [inactive]='bpContact?.contact?.deleted'>
      </well-person-circle>
      <div class='ml'>
        <div class='position-relative'>
          @if (isPublic() !== undefined) {
            <div class='position-absolute icon-container'
                 pTooltip="{{isPublic() === true ? ('utils.publicContact' | translate) : ('utils.partnerContact' | translate)}}">
              <i class='color-white fa-solid {{isPublic() === true ? "fa-eye" : "fa-eye-slash"}}'></i>
            </div>
          }
          <span>{{ bpContact?.contact?.contactName }}</span>
          @if (showCompanyForContact) {
            <span>
              (<span class='fst-italic'>{{ bpContact?.contact?.companyName }}</span>)
            </span>
          }
        </div>
        <div>{{ bpContact?.contact?.email }}</div>
        @if (bpContact?.contact?.phoneNumber) {
          <div class='d-flex align-items-center gap-1 flex-wrap'>
            <i class='fa-solid fa-phone color-gray-3 fa-xs'></i>
            {{ bpContact?.contact?.phoneNumber }}
          </div>
        }
      </div>
    </div>

    @if (displayCheckbox()) {
      <div class='flex-grow-0 text-align-center'>
        <p-checkbox [binary]='true'
                    [(ngModel)]='bpContact.selected'
                    (onChange)='onChange($event)'
                    [disabled]='readOnly'
                    [readonly]='readOnly' data-testid="selected-checkbox"></p-checkbox>
      </div>
    }
  </div>
</div>


